import React from 'react';
import { AbTestFormData } from '../../shared/abTestModalUtils';
import { numberToLetter } from '@utils/number-utils';

interface PdpPreviewTabProps {
  formData: AbTestFormData;
}

export const PdpPreviewTab: React.FC<PdpPreviewTabProps> = ({ formData }) => {
  const selectedVariants = formData.abTestVariants
    .filter((v) => v.isSelected)
    .sort((a, b) => (a.slotIndex ?? 0) - (b.slotIndex ?? 0));

  return (
    <div className="ab-test-modal-preview-tab">
      <p>
        Force a specific variation to preview it yourself, without relying on traffic allocation. Only available while
        the test is running.
      </p>
      <p>
        To preview a variation, add "
        <span className="ab-test-modal-preview-tab__purple-text">?abTestProductPromise=</span>" followed by the
        variation letter to any product page URL. For example:
      </p>
      <p>
        <span className="ab-test-modal-preview-tab__purple-text">
          https://storeName.myshopify.com/products/example?abTestProductPromise=a
        </span>
      </p>
      <div className="ab-test-modal-preview-tab__variants-container">
        <p className="ab-test-modal-preview-tab__variants-title">Your variations</p>
        {selectedVariants.map((variant, index) => {
          const variantLetter = numberToLetter(index + 1).toLowerCase();
          const variantLabel = numberToLetter(index + 1);
          const isControl = variantLabel === 'A';
          return (
            <p key={variant.widgetExternalId || index}>
              <span className="ab-test-modal-preview-tab__variant-info">
                <span className="ab-test-modal-preview-tab__variant-letter">{variantLabel}</span>
                <span>
                  {variant.name}
                  {isControl ? ' (Control)' : ''}
                </span>
              </span>
              <span className="ab-test-modal-preview-tab__query-param">abTestProductPromise={variantLetter}</span>
            </p>
          );
        })}
      </div>
      <p className="ab-test-modal-preview-tab__note">
        If you've mapped checkout groups to this test, the matching checkout experience will also be applied. Use
        incognito window for accurate testing.
      </p>
    </div>
  );
};
